import React, { Component } from 'react';
import { BrowserRouter, Route, Switch,  } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import Professional from './Pages/Professional';
import ProjectDetails from './Pages/ProjectDetails';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default class App extends Component {
  componentDidMount() {
    if (window.innerWidth <= 700) return AOS.init({ disable: true });
    AOS.init({ disable: "phone"})
  }

  componentDidUpdate() {
    AOS.refresh();
  }
  
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={ HomePage } />
          <Route exact path="/professional" component={ Professional } />
          <Route exact path="/project/:id" component={ ProjectDetails } />
        </Switch>
      </BrowserRouter>
    )
  }
}